import i18next from 'i18next';

i18next.addResources('es_CL', 'RejectedOrderManager', {
  rejectedOrders: 'Rechazadas',
  history: 'Historial',
  store_delivery: 'Delivery',
  in_store: 'Retiro en tienda',
  orderId: 'ID de pedido y cliente',
  createdAt: 'Fecha y hora',
  dispatchMethod: 'Tipo de entrega',
  store: 'Tienda',
  actions: 'Acciones',
  rejectedOrdersTitle: 'Ordenes rechazadas',
  historyTitle: 'Historial',
  posId: 'POS ID',
  downloadReport: 'Descargar Reporte',
  assignedOrder: 'Orden ya asignada',
  assignOrder: 'Asignar orden',
  injectedBy: 'Ingresado por',
  assigned: 'Orden {{orderId}} asignada correctamente.',
  assignedTo: 'Asignada a',
  assignedError: 'No se pudo asignar la orden {{orderId}}, intente nuevamente.',
  cancelButtonLabel: 'Cancelar',
  confirm: 'Confirmar ingreso',
  injectOrderTitle: 'Confirmar ingreso de la orden #',
  externalIdLabel: 'Número del albarán',
  injectionSuccess: 'La orden {{orderId}} fue ingresada satisfactoriamente.',
  injectionError: 'No pudo ingresarse la orden {{orderId}}, intente nuevamente.',
  download: 'Descargar',
  posError: 'POS Error',
  downloadedReport: 'Descarga exitosa',
  storeCode: 'Código de tienda',
  paymentMethod: 'Método de pago',
  orderTotal: 'Total de la orden'
});

i18next.addResources('es_CR', 'RejectedOrderManager', {
  rejectedOrders: 'Rechazadas',
  history: 'Historial',
  store_delivery: 'Delivery',
  in_store: 'Retiro en tienda',
  orderId: 'ID de pedido y cliente',
  createdAt: 'Fecha y hora',
  dispatchMethod: 'Tipo de entrega',
  store: 'Tienda',
  actions: 'Acciones',
  rejectedOrdersTitle: 'Ordenes rechazadas',
  historyTitle: 'Historial',
  posId: 'POS ID',
  downloadReport: 'Descargar Reporte',
  assignedOrder: 'Orden ya asignada',
  assignOrder: 'Asignar orden',
  injectedBy: 'Ingresado por',
  assigned: 'Orden {{orderId}} asignada correctamente.',
  assignedTo: 'Asignada a',
  assignedError: 'No se pudo asignar la orden {{orderId}}, intente nuevamente.',
  cancelButtonLabel: 'Cancelar',
  confirm: 'Confirmar ingreso',
  injectOrderTitle: 'Confirmar ingreso de la orden #',
  externalIdLabel: 'Número del albarán',
  injectionSuccess: 'La orden {{orderId}} fue ingresada satisfactoriamente.',
  injectionError: 'No pudo ingresarse la orden {{orderId}}, intente nuevamente.',
  download: 'Descargar',
  posError: 'POS Error',
  downloadedReport: 'Descarga exitosa'
});
